import React, { useEffect, useRef, useState } from 'react';
import { Subject } from "rxjs";
import { FormPane } from "../../components/FormZero/PageComponents/FormPane/FormPane";
import { DataGridPro as DataGrid, DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import axios from "axios";
import { Button as MUIButton, Paper, Stack, Box, Grid } from '@mui/material';
import { ActionPanel } from "../../components/FormZero/ActionPanel/ActionPanel";
import * as XLSX from "xlsx";
import { TextField } from "@mui/material";
import SearchChips from '../../components/SearchChips';
import { ISearchChips } from '../../interfaces/Core/ISearchChips';
import ActionMenu from '../../components/ActionMenu';
import ActionButton from '../../components/ActionButton';
import { CustomDataGrid } from '../../components/StripedDataGrid'
import { IApplication } from '../../interfaces/IApplication';
import { useAppDispatch } from '../../hooks';
import { setPageTitle } from '../../slices/applicationSlice';
import moment from 'moment';
import { IDeliveryHeader } from '../../interfaces/Logistics/IDeliveryHeader';
import CheckIcon from '@mui/icons-material/FactCheck';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { ISeedDemand } from '../../interfaces/SeedDemands/ISeedDemand';
import ConfirmDialog, { confirmDialog } from '../../components/ConfirmDialog';
import { alpha, styled } from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useForm, SubmitHandler } from 'react-hook-form';
import { ISeedInventory } from '../../interfaces/Seeding/ISeedInventory';

function PanelView(props: { dataSource: any; selectedRows: any; }) {
    const { dataSource, selectedRows } = props;

    const [showDownloadDialog, setShowDownloadDialog] = React.useState(false);
    const [showBulkVerifyDialog, setBulkVerifyDialog] = React.useState(false);

    async function downloadReport() {
        try {
            let r = [...dataSource].filter(r => r.is_ordered === 0).map(r => {
                let z = { ...r };
                delete z['id'];
                return z;
            });
            // let s = [header, ...r];

            const ws = XLSX.utils.json_to_sheet(r);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Export');

            XLSX.writeFile(wb, "SeedToBeOrdered.xls"); // <-- just do it this way.
            // TODO: submit to server the ones that have now been printed

            console.log(dataSource);

            let data = { items: dataSource.filter((r: { is_ordered: number; }) => r.is_ordered === 0).map((x: { id: any; }) => x.id), value: 1 };
            const resp = await axios.put(
                `/seeding/markOrdered`,
                data
            );
            console.log(resp);
        } catch (e: any) {
            console.log(e)
            alert(e.message);
        }
    }

    async function bulkMarkVerified() {
        console.warn("bulkMarkVerified not implemented");
        // return;

        try {
            // TODO: grab the ones that are selected and mark them as verified
            // let r = [...dataSource].filter(r => r.is_ordered === 1 && selectedRows.indexOf(r.id) > -1).map(r => {
            //     let z = {...r};
            //     delete z['id'];
            //     // r['truck'] = r['truck'].truck_number;
            //     return z;
            // });
            // let s = [header, ...r];

            let data = { items: dataSource.filter((r: { is_ordered: number; id: any; }) => r.is_ordered === 1 && selectedRows.indexOf(r.id) > -1).map((x: { id: any; }) => x.id), value: 2 };
            console.log(data);
            // return;
            const resp = await axios.put(
                `/seeding/markOrdered`,
                data
            );
            console.log(resp);
        } catch (e: any) {
            console.log(e)
            alert(e.message);
        }
    }

    return (
        <>
            <div className="SprayRecordsGrid_PanelView">
                {/*PanelContents*/}
                <div className="row">
                    <div className="col-6">
                        {/* <Button fullWidth={true} className="button-square" clickHandler={() => setShowDownloadDialog(true)} text={"Download Seed To Order File"} /> */}
                        {(showDownloadDialog) && (
                            <Dialog
                                open={true}
                                onClose={() => setShowDownloadDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                                    Download Seed To Order File
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Click Download to Download Seed To Order File
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    {/*  <Button onClick={() => downloadReport()} autoFocus text={"Download"} fullWidth={true} />
                                    <Button onClick={() => setShowDownloadDialog(false)} autoFocus text={"Close"} fullWidth={true} /> */}
                                </DialogActions>
                            </Dialog>
                        )}
                    </div>
                    <div className="col-6">
                        {/*  <Button fullWidth={true} className="button-square" clickHandler={() => setBulkVerifyDialog(true)} text={"Bulk Verify"} /> */}
                        {(showBulkVerifyDialog) && (
                            <Dialog
                                open={true}
                                onClose={() => setBulkVerifyDialog(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                                    Bulk Verify
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Click Here to Verify All Selected Seed Orders
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    {/* <Button onClick={() => bulkMarkVerified()} autoFocus text={"Verify"} fullWidth={true} />
                                    <Button onClick={() => setBulkVerifyDialog(false)} autoFocus text={"Close"} fullWidth={true} /> */}
                                </DialogActions>
                            </Dialog>
                        )}
                    </div>
                </div>

            </div>
        </>
    )
}

function ChangeStatusDialog(props: { cellValues: any; isLoadingCompleted: any; updateUI: any; }) {
    const { cellValues, isLoadingCompleted, updateUI } = props;

    const [isOpen, setOpen] = React.useState(false);
    const onCellEditCommit = async (cellEdit: { id: any; field: any; value: any; }) => {
        console.log(cellEdit);
        let data = { field: cellEdit.field, value: cellEdit.value };
        const resp = await axios.put(
            `/seeding/status/${cellEdit.id}`,
            data
        );
        await updateUI();
        setOpen(false);
        console.log(resp);
    }

    const buttons = [
        {
            value: 0,
            label: "Canceled"
        },
        {
            value: 1,
            label: "Ordered & Unverified"
        },
        {
            value: 2,
            label: "Verified"
        },
    ];

    return (<>
        <MUIButton fullWidth={true} disabled={isLoadingCompleted} variant={'contained'} color={"secondary"} onClick={() => setOpen(true)}>Status: {cellValues.row.comment !== null ? cellValues.row.comment : "OK"}</MUIButton>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Update Status
            </DialogTitle>
            <DialogContent style={{ width: '500px', textAlign: 'center' }}>
                <DialogContentText id="alert-dialog-description">
                    {cellValues.row.species} - {cellValues.row.itemClass} - {cellValues.row.variety}
                </DialogContentText>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                    {buttons.map((btn) => {
                        return (<MUIButton disabled={isLoadingCompleted} fullWidth={true} variant={'contained'} color={"secondary"} onClick={() => {
                            onCellEditCommit({
                                id: cellValues.id,
                                field: "is_ordered",
                                value: btn.value
                            }).then(() => {
                                setOpen(false)
                            })
                        }}>{btn.label}</MUIButton>);
                    })}
                </div>

            </DialogContent>
            <DialogActions>
                <MUIButton onClick={() => setOpen(false)}>Close</MUIButton>
            </DialogActions>
        </Dialog>
    </>)
}

export function SeedReceiving(props: any) {

    const dispatch = useAppDispatch();

    useEffect(() => {

        let appState: IApplication = {
            pageTitle: "Seed Receiving"
        }
        dispatch(setPageTitle(appState));
    }, []);
    const { } = props;


    const filterFormStructure = [
        { key: "week_year", type: "week-filter", size: { default: 4 }, label: "Week", required: true },
        { key: "week_year_view", type: "header", size: { default: 4 }, valueKey: "week_year" },
    ];
    const filterFormSubject = new Subject();
    const [formFilter, setFormFilter] = React.useState({});
    filterFormSubject.subscribe((n: any) => setFormFilter(n));




    const columns: GridColDef[] = [
        // tray size,
        { field: "id", headerName: "ID", width: 200, hide: true },
        {
            field: "receive_button", headerName: " ", width: 200,
            renderCell: (cellValues: any) => {
                return (<ChangeStatusDialog cellValues={cellValues} isLoadingCompleted={false} updateUI={loadData} />);
            }
        },
        { field: "species", headerName: "Species", width: 200 },
        { field: "variety", headerName: "Variety", width: 200 },
        { field: "itemClass", headerName: "Class", width: 200 },
        { field: "quantityOrdered", headerName: "Quantity Ordered", width: 200 },
        { field: "quantityReceived", headerName: "Quantity Received", width: 200 },
        {
            field: "orderedDate", type: 'date', editable:true, headerName: "Ordered Date", align: 'center', width: 125, valueFormatter: params =>
                moment(params?.value).format("MM/DD/YYYY")
        },
    ]

    const [selectionModal, setSelectionModal] = React.useState([]);

    const [rows, setRows] = React.useState<ISeedInventory[]>([]);
    const [page, setPage] = React.useState(1);
    const loadData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/SeedInventories`);
            setRows(response.data);

            // setRows(response.data.data);
            //               setCurrentPage(response.data.current_page);
            //                 setTotalPage(response.data.total);
        } catch (e) {
            console.error(e);
        }
    };
    React.useEffect(() => {
        loadData().then();
    }, [])

    const panel = (<PanelView dataSource={rows} selectedRows={selectionModal} />);

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }

    const buttons = [
        <ActionButton action={AddPOClicked} buttonLabel="ADD NEW PO" />
    ];

    const inputFile = useRef<HTMLInputElement | null>(null);

    const onButtonClick = () => {
        console.log("ON BUTTON CLICK");
        inputFile.current?.click();
        console.log(inputFile.current);
    }

    const handleFileSelected = (e: React.ChangeEvent<HTMLInputElement>): void => {
        console.log("Hello!");
        if (e.target.files != null) {
            const files = Array.from(e.target.files);
            const headers = {
                'Content-Type': 'multipart/form-data'
            }
            var bodyFormData = new FormData();
            bodyFormData.append('files', files[0]);
            axios.post(`${process.env.REACT_APP_ENDPOINT}/api/SeedDemands/demand-upload`, bodyFormData, {
                headers: headers
            }).then((data) => {
                console.log(data);
            });
        }
    }

    const [open, setOpen] = useState(false);

    function AddPOClicked(_event: React.MouseEvent<HTMLElement>): void {

        setOpen(true);
    }


    function handleClose() {
        setOpen(!open);
    }

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: 0,
        borderRadius: 0,
        boxShadow: "none",
    }));

    const { register, handleSubmit, control, formState: { errors }, reset, setValue, getValues } = useForm<ISeedInventory>({});

    const onSubmit: SubmitHandler<ISeedInventory> = data => {
        console.log("In Submit");
        if (data.id > 0) {
            const response = axios.put<ISeedInventory>(`${process.env.REACT_APP_ENDPOINT}/api/SeedInventories/instock`).then((resp) => {
                console.log(response);
            });
        } else {
            const response = axios.post<ISeedInventory>(`${process.env.REACT_APP_ENDPOINT}/api/SeedInventories`, data).then((resp) => {
                loadData();
            });
        }
    };

    return (
        <>
            <input type='file' id='file' ref={inputFile} onChange={handleFileSelected} style={{ display: 'none' }} />
            <ActionMenu buttons={buttons}></ActionMenu>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <ThemeProvider theme={darkTheme}>
                    <SearchChips handleSearch={handleSearchChips}></SearchChips>
                </ThemeProvider>
                <div style={{
                    flexGrow: 1
                }}>
                    <CustomDataGrid
                        sx={{ backgroundColor: 'white' }}
                        rows={rows}
                        columns={columns}
                        rowsPerPageOptions={[15]}
                        page={page}
                        pageSize={15}
                        onPageChange={((page: React.SetStateAction<number>, details: any) => {
                            setPage(page)
                        })}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        // onCellEditCommit={onCellEditCommit}
                        selectionModel={selectionModal}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                    />
                </div>
            </div>

            <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
                <DialogTitle>Add PO</DialogTitle>
                <Box component="form" /* onSubmit={handleSubmit(onSubmit)} */>
                    <DialogContent>
                        <Grid container spacing={0} >
                            <Grid item xs={6}>
                                <Item>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        id="brokermaterialnumber"
                                        label="Broker Material Number"
                                        {...register('brokerMaterialNumber')} />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        id="traycount"
                                        label="Tray Count"
                                        {...register('trays')} />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        id="quantityordered"
                                        label="Quantity Ordered"
                                        {...register('quantityOrdered')} />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        id="traysize"
                                        label="TraySize"
                                        {...register('traySize')} />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        id="buffer"
                                        label="Buffer"
                                        {...register('buffer')} />
                                </Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Item>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        id="seedsPerCell"
                                        label="Seeds Per Cell"
                                        {...register('seedsPerCell')} />
                                </Item>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button size='large' onClick={handleClose}>Cancel</Button>
                        <Button size='large' type='submit' variant="contained" color="success" onClick={() => confirmDialog("Are you sure you want to add this PO?", handleSubmit(onSubmit))}>Add NeW PO</Button>
                    </DialogActions>
                    <ConfirmDialog />
                </Box>
            </Dialog>

        </>);
}